import React, { useEffect, useState } from "react";
import { FaDownload, FaTrashAlt } from "react-icons/fa";
import "../styles/TableView.css";
// CAMBIO 1: Importamos desde el nuevo servicio unificado
import { listFiles, downloadFile, deleteFile } from "../services/files";
import { useAuth } from "react-oidc-context";

const TableView = ({ userId }) => {
  const auth = useAuth();
  const [userGroups, setUserGroups] = useState([]);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  // CAMBIO 2: Obtenemos grupos directo del Token (Instantáneo y seguro)
  useEffect(() => {
    if (auth.user?.profile) {
      const groups = auth.user.profile["cognito:groups"] || [];
      setUserGroups(groups);
    }
  }, [auth.user]);

  // Listar archivos
  useEffect(() => {
    const fetchFiles = async () => {
      // Solo buscamos si hay usuario
      if (!auth.user) return;

      setLoading(true);
      try {
        // CAMBIO 3: Ya no pasamos idToken manual, el interceptor (api.js) lo pone solo.
        const allFiles = await listFiles(userGroups);
        setFiles(allFiles);
      } catch (error) {
        console.error("Error al listar archivos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFiles();
  }, [userGroups, auth.user]); // Dependencias corregidas

  // Función auxiliar para actualizar la lista tras borrar
  const handleRefresh = () => {
    // Re-ejecutar la carga
    listFiles(userGroups).then(setFiles).catch(console.error);
  };

  if (loading) return <div>Cargando archivos...</div>;

  return (
    <div className="table-container">
      <table className="file-table">
        <thead>
          <tr>
            <th>Nombre de Archivo</th>
            <th>Equipo</th>
            <th>Descargar</th>
            <th>Eliminar</th>
          </tr>
        </thead>
        <tbody>
          {files.map((file, index) => (
            <tr key={index}>
              <td>{file.name}</td>
              {/* Ajusta 'file.group' según lo que devuelva tu API real */}
              <td>{file.group || "General"}</td>
              <td>
                <button
                  className="icon-button"
                  onClick={() => downloadFile(file)}
                >
                  <FaDownload className="icon-download" />
                </button>
              </td>
              <td>
                <button
                  className="icon-button"
                  onClick={() => deleteFile(file, handleRefresh)}
                >
                  <FaTrashAlt className="icon-delete" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableView;
